import { toDateOnlyString } from '@urbanx/agx.ui-components2';

/**
 * Deep-clone form data and convert Date values to YYYY-MM-DD strings so saved values
 * preserve the calendar date (e.g. "2026-02-21") instead of UTC ISO ("2026-02-20T14:00:00.000Z").
 */
export const normalizeFormDates = <T>(data: T): T => {
  if (data instanceof Date) {
    return toDateOnlyString(data) as T;
  }
  if (Array.isArray(data)) {
    return data.map(normalizeFormDates) as unknown as T;
  }
  if (data != null && typeof data === 'object') {
    const out: Record<string, unknown> = {};
    for (const [k, v] of Object.entries(data)) {
      if (k === 'validationErrors') continue;

      out[k] = normalizeFormDates(v);
    }
    return out as unknown as T;
  }
  return data;
};
